import React, { useState, useEffect } from 'react';
import { 
  User, Calculator, Check, X,
  Clock, AlertTriangle, CheckCircle, Calendar, Users,
  CreditCard, Search, GraduationCap,
  ArrowLeft, FolderOpen, ChevronLeft, ChevronRight, Brain, Banknote, Badge, BookOpen, DollarSign, AlertCircle
} from 'lucide-react';
import { api } from '../services/api';
import { motion } from 'framer-motion';
import ConfirmDialog from './ConfirmDialog';
import { Toast } from "../components/ui/Toast";
import HistoriqueEnseignantsModal from './HistoriqueEnseignantsModal';
import { SalaryModificationHistoryModal, SalaryModificationRequestModal } from './SalaryModificationModals';
import NoticePaiementCourte from './paie/NoticePaiementCourte';


const ComptabiliteEnseignants = ({
  selectedDate,
  setSelectedDate,
  showCalendar,
  setShowCalendar,
  modesPaiement,
  loadModesPaiement,
  anneeActive,
  showToast,
  formatDateForDisplay,
  goToPreviousMonth,
  goToNextMonth,
  onBackToDashboard,
  salaryAuthorization
}) => {
  // États locaux
  const [modeContrat, setModeContrat] = useState('horaire');
  const [enseignants, setEnseignants] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showValidationDialog, setShowValidationDialog] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [selectedModePaiement, setSelectedModePaiement] = useState('');
  const [paiementExistant, setPaiementExistant] = useState(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [calculationValidated, setCalculationValidated] = useState(false);
  const [paymentValidated, setPaymentValidated] = useState(false);
  const [showCloturePaiementDialog, setShowCloturePaiementDialog] = useState(false);
  const [enseignantsPaies, setEnseignantsPaies] = useState({});
  const [showHistoriqueEnseignants, setShowHistoriqueEnseignants] = useState(false);
  const [showRetenueModal, setShowRetenueModal] = useState(false);
  const [selectedPresence, setSelectedPresence] = useState(null);
  const [retenueAbsence, setRetenueAbsence] = useState('');
  const [typeRetenue, setTypeRetenue] = useState('avec');
  const [justificationPasDeRetenue, setJustificationPasDeRetenue] = useState('');
  const [showJustificationValidationModalEnseignant, setShowJustificationValidationModalEnseignant] = useState(false);
  const [justificationValidationEnseignant, setJustificationValidationEnseignant] = useState('');
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [showModalEnfantsCharge, setShowModalEnfantsCharge] = useState(false);
  const [selectedEnseignantEnfantsDetail, setSelectedEnseignantEnfantsDetail] = useState(null);
  const [salaryRequestEnseignant, setSalaryRequestEnseignant] = useState(null);
  const [salaryHistoryEnseignant, setSalaryHistoryEnseignant] = useState(null);

  const [isModePaiementDropdownOpen, setIsModePaiementDropdownOpen] = useState(false);
  const [modePaiementSearchTerm, setModePaiementSearchTerm] = useState('');
  const [paymentStep, setPaymentStep] = useState('payment'); // 'payment' | 'cloture'


  useEffect(() => {
    loadEnseignantsData();
  }, [selectedDate, modeContrat]);

  useEffect(() => {
    loadModesPaiement();
  }, []);

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ show: false, message: '', type: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  const localShowToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const salaryPaymentLocked = salaryAuthorization?.paiement_autorise === false;
  const salaryLockReasons = salaryAuthorization?.raisons_blocage || [];
  const getSalaryLockMessage = () => salaryLockReasons[0] || "Paiement des salaires verrouillé. Validez l'état des salaires et la dotation centrale avant paiement.";

  const SalaryLockPanel = () => salaryPaymentLocked ? (
    <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
        <div>
          <p className="font-semibold">Paiement verrouille</p>
          <p className="text-xs">{getSalaryLockMessage()}</p>
        </div>
      </div>
    </div>
  ) : null;


  // Fermer dropdown mode paiement au clic extérieur
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (isModePaiementDropdownOpen && !event.target.closest('.mode-paiement-dropdown')) {
      setIsModePaiementDropdownOpen(false);
    }
  };
  
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [isModePaiementDropdownOpen]);



  const handleOpenRetenueAbsenceEnseignant = (pointage) => {
    console.log('🔴 Ouverture modale retenue enseignant:', pointage);
    setSelectedPresence(pointage);
    setRetenueAbsence(pointage.retenue_absence || '');
    setTypeRetenue(pointage.retenue_absence !== null ? 'avec' : 'sans');
    setJustificationPasDeRetenue(pointage.justification_pas_de_retenue || '');
    setShowRetenueModal(true);
  };



 const loadEnseignantsData = async () => {
  try {
    setLoading(true);
    const mois = selectedDate.getMonth() + 1;
    const annee = selectedDate.getFullYear();

    console.log(`📊 Chargement des enseignants pour ${mois}/${annee}`);

    const response = await api.comptabilite.getEnseignantsAvecPointages(
      mois.toString().padStart(2, '0'), 
      annee.toString(),
      anneeActive?.id || localStorage.getItem('annee_scolaire_id')
    );

    console.log('📦 Réponse API brute:', response);

    if (response.success) {
      console.log(`✅ ${response.data?.length || 0} enseignants reçus`);
      
      if (response.data && response.data.length > 0) {
        const firstTeacher = response.data[0];
        console.log('🔍 Premier enseignant:', {
          id: firstTeacher.id,
          nom: firstTeacher.nom,
          prenom: firstTeacher.prenom,
          nombre_pointages: firstTeacher.pointages?.length || 0
        });
        
        if (firstTeacher.pointages && firstTeacher.pointages.length > 0) {
          const firstPointage = firstTeacher.pointages[0];
          console.log('🔍 Premier pointage du premier enseignant:', {
            id: firstPointage.id,
            date: firstPointage.date_pointage,
            statut: firstPointage.statut_debut,
            retenue_absence: firstPointage.retenue_absence,
            justification_pas_de_retenue: firstPointage.justification_pas_de_retenue
          });
        } else {
          console.log('⚠️ Aucun pointage pour le premier enseignant');
        }

        for (const teacher of response.data) {
          if (teacher.pointages) {
            const pointage3 = teacher.pointages.find(p => p.id === 3);
            if (pointage3) {
              console.log('🎯 POINTAGE ID=3 TROUVÉ:', {
                enseignant: `${teacher.prenom} ${teacher.nom}`,
                date: pointage3.date_pointage,
                statut: pointage3.statut_debut,
                retenue_absence: pointage3.retenue_absence,
                justification_pas_de_retenue: pointage3.justification_pas_de_retenue
              });
            }
          }
        }
      }

      // ✅ NOUVEAU : Construire les enseignants avec avances (comme ComptabilitePersonnel)
      const paiementsStatus = {};
      const enseignantsAvecAvances = await Promise.all(
        (response.data || []).map(async (teacher) => {
          try {
            const paiementResponse = await api.paiementsSalaires.verifierPaiementEnseignantExistant(
              teacher.id,
              mois,
              annee
            );

            if (paiementResponse.success && paiementResponse.existe) {
              paiementsStatus[teacher.id] = true;
            }

            // ✅ Extraire les avances depuis la réponse
            const avances = paiementResponse.avances || [];
            const montant_avances = paiementResponse.montant_avances || 0;

            console.log(`💰 Enseignant ${teacher.prenom} ${teacher.nom}: ${avances.length} avance(s), ${montant_avances} FCFA`);

            return {
              ...teacher,
              avances_mois: avances,
              montant_avances_total: montant_avances
            };

          } catch (error) {
            console.error(`❌ Erreur vérification paiement enseignant ${teacher.id}:`, error);
            return {
              ...teacher,
              avances_mois: [],
              montant_avances_total: 0
            };
          }
        })
      );

      setEnseignants(enseignantsAvecAvances);
      setEnseignantsPaies(paiementsStatus);
      
      console.log('💰 Paiements existants:', paiementsStatus);

    } else {
      setEnseignants([]);
      setEnseignantsPaies({});
      console.error('❌ Erreur:', response.message);
    }
  } catch (error) {
    console.error('❌ Erreur chargement enseignants:', error);
    setEnseignants([]);
    setEnseignantsPaies({});
  } finally {
    setLoading(false);
  }
};




  const verifierPaiementExistant = async (teacherId) => {
    try {
      const mois = selectedDate.getMonth() + 1;
      const annee = selectedDate.getFullYear();
      
      console.log(`🔍 Vérification paiement enseignant: ${teacherId}, ${mois}/${annee}`);
      
      const response = await api.paiementsSalaires.verifierPaiementEnseignantExistant(
        teacherId,
        mois,
        annee
      );
      
      console.log('📡 Réponse vérification:', response);
      
      if (response.success && response.existe) {
        setPaiementExistant(response.paiement);
        setPaymentValidated(true);
        setCalculationValidated(true);
        
        setEnseignantsPaies(prev => ({
          ...prev,
          [teacherId]: true
        }));
        
        console.log('✅ Paiement existant trouvé:', response.paiement);
      } else {
        setPaiementExistant(null);
        setPaymentValidated(false);
        setCalculationValidated(false);
        
        setEnseignantsPaies(prev => {
          const newState = {...prev};
          delete newState[teacherId];
          return newState;
        });
        
        console.log('ℹ️ Aucun paiement existant');
      }
    } catch (error) {
      console.error('❌ Erreur vérification paiement:', error);
      setPaiementExistant(null);
      setPaymentValidated(false);
      setCalculationValidated(false);
    }
  };

  const handleSaveRetenueAbsenceEnseignant = async () => {
    console.log('🔵 ========== DÉBUT handleSaveRetenueAbsenceEnseignant ==========');
    
    if (typeRetenue === 'avec' && !retenueAbsence) {
      localShowToast('Veuillez saisir le montant de la retenue', 'error');
      return;
    }

    if (!justificationPasDeRetenue.trim()) {
      localShowToast('Veuillez saisir une justification', 'error');
      return;
    }

    try {
      localShowToast('Enregistrement de la retenue en cours...', 'loading');
      
      const montant = typeRetenue === 'avec' ? parseFloat(retenueAbsence) : 0;
      const justification = justificationPasDeRetenue.trim();
      
      console.log('💾 Retenue enregistrée temporairement (ENSEIGNANT):', {
        employe_id: selectedPresence?.employe_id,
        type: selectedPresence?.type,
        montant,
        justification,
        typeRetenue
      });
      
      setEnseignants(prev => prev.map(ens => {
        if (ens.id === selectedPresence?.employe_id) {
          const updatedEns = {
            ...ens,
            retenue_temp: montant,
            justification_retenue_temp: justification
          };
          
          console.log('✅ Enseignant mis à jour dans le state:', {
            id: updatedEns.id,
            nom: `${updatedEns.prenom} ${updatedEns.nom}`,
            type_contrat: updatedEns.type_contrat,
            retenue_temp: updatedEns.retenue_temp,
            justification: updatedEns.justification_retenue_temp
          });
          
          return updatedEns;
        }
        return ens;
      }));
      
      setShowRetenueModal(false);
      
      if (typeRetenue === 'avec') {
        localShowToast(`Retenue de ${montant.toLocaleString()} FCFA enregistrée. Elle sera déduite lors du paiement.`, 'success');
      } else {
        localShowToast('Absence de retenue enregistrée avec justification.', 'success');
      }
      
      console.log('✅ ========== FIN handleSaveRetenueAbsenceEnseignant ==========');
      
    } catch (error) {
      console.error('💥 Exception capturée dans handleSaveRetenueAbsenceEnseignant:', error);
      localShowToast('Erreur lors de l\'enregistrement', 'error');
    }
  };



  const calculerRemunerationMensuelle = (teacher) => {
  if (!teacher || !teacher.pointages) return null;

  const lignes = teacher.pointages.map(pointage => {
    const dureeMinutes = pointage.duree_effective_minutes || 0;
    const dureeHeures = (dureeMinutes / 60).toFixed(2);
    const tauxHoraire = pointage.taux_horaire || 0;
    const montant = (parseFloat(dureeHeures) * parseFloat(tauxHoraire)).toFixed(0);

    return {
      id: pointage.id,
      date: pointage.date_pointage,
      classe: pointage.classe_nom,
      matiere: pointage.matiere_nom || '-',
      dureeMinutes: dureeMinutes,
      dureeHeures: dureeHeures,
      tauxHoraire: tauxHoraire,
      montant: montant,
      retenueAbsence: parseFloat(pointage.retenue_absence || 0),
      justificationPasDeRetenue: pointage.justification_pas_de_retenue
    };
  });

  const totalHeures = lignes.reduce((sum, ligne) => sum + parseFloat(ligne.dureeHeures), 0).toFixed(2);
  const totalRemunerationBrute = lignes.reduce((sum, ligne) => sum + parseFloat(ligne.montant), 0);
  
  const totalRetenuesPresences = lignes.reduce((sum, ligne) => sum + ligne.retenueAbsence, 0);
  
  let retenueGlobale = 0;
  if (teacher.retenue_temp && teacher.retenue_temp > 0) {
    retenueGlobale = parseFloat(teacher.retenue_temp);
  }
  
  // 🆕 Retenues enfants à charge (automatiques)
  const retenuesEnfantsCharge = teacher.retenues_enfants_charge?.montant_total || 0;
  const nombreEnfantsCharge = teacher.retenues_enfants_charge?.nombre_enfants || 0;
  const detailEnfantsCharge = teacher.retenues_enfants_charge?.detail_enfants || [];
  
  // 🆕 Inclure dans le total des retenues
  const totalRetenues = totalRetenuesPresences + retenueGlobale + retenuesEnfantsCharge;
  
  const totalAvances = teacher.montant_avances_total || 0;
  const totalRemunerationNette = totalRemunerationBrute - totalRetenues - totalAvances;

  return {
    lignes: lignes,
    nombrePointages: lignes.length,
    totalHeures: totalHeures,
    totalRemunerationBrute: totalRemunerationBrute,
    totalRetenues: totalRetenues,
    totalRetenuesPresences: totalRetenuesPresences,
    retenueGlobale: retenueGlobale,
    retenues_enfants_charge: retenuesEnfantsCharge,      // 🆕
    nombre_enfants_charge: nombreEnfantsCharge,          // 🆕
    detail_enfants_charge: detailEnfantsCharge,          // 🆕
    totalAvances: totalAvances,
    totalRemunerationNette: totalRemunerationNette
  };
  };



  const calculerRemunerationFixe = (teacher) => {
  if (!teacher || !teacher.pointages) return null;

  const salaireBase = parseFloat(teacher.salaire_fixe || 0);
  const statistiques = teacher.statistiques || {};
  
  const totalRetenuesPresences = statistiques.total_retenues || 0;

  let retenueGlobale = 0;
  if (teacher.retenue_temp && teacher.retenue_temp > 0) {
    retenueGlobale = parseFloat(teacher.retenue_temp);
  }

  // 🆕 Retenues enfants à charge (automatiques)
  const retenuesEnfantsCharge = teacher.retenues_enfants_charge?.montant_total || 0;
  const nombreEnfantsCharge = teacher.retenues_enfants_charge?.nombre_enfants || 0;
  const detailEnfantsCharge = teacher.retenues_enfants_charge?.detail_enfants || [];

  // 🆕 Inclure dans le total des retenues
  const totalRetenues = totalRetenuesPresences + retenueGlobale + retenuesEnfantsCharge;
  
  const totalAvances = teacher.montant_avances_total || 0;

  const mois = selectedDate.getMonth();
  const annee = selectedDate.getFullYear();
  const joursOuvres = [];
  
  const premierJour = new Date(annee, mois, 1, 12, 0, 0);
  const dernierJour = new Date(annee, mois + 1, 0, 12, 0, 0);
  
  for (let jour = new Date(premierJour); jour <= dernierJour; jour.setDate(jour.getDate() + 1)) {
    const jourSemaine = jour.getDay();
    if (jourSemaine !== 0) {
      const dateStr = `${jour.getFullYear()}-${String(jour.getMonth() + 1).padStart(2, '0')}-${String(jour.getDate()).padStart(2, '0')}`;
      joursOuvres.push(dateStr);
    }
  }

  const datesPointees = teacher.pointages.map(p => {
    const date = new Date(p.date_pointage);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  });
  
  const joursManquants = joursOuvres.filter(jour => !datesPointees.includes(jour));
  const salaireNet = salaireBase - totalRetenues - totalAvances;


  
  // ✅ CORRECTION : Compter directement depuis les pointages
const joursNonTravailles = teacher.pointages.filter(p => p.statut === 'jour_non_travaille').length;
const vraisAbsences = teacher.pointages.filter(p => p.statut === 'absent').length;

  return {
    salaire_base: salaireBase,
    total_retenues: totalRetenues,
    total_retenues_presences: totalRetenuesPresences,
    retenue_globale: retenueGlobale,
    retenues_enfants_charge: retenuesEnfantsCharge,
    nombre_enfants_charge: nombreEnfantsCharge,
    detail_enfants_charge: detailEnfantsCharge,
    total_avances: totalAvances,
    salaire_net: salaireNet,
    total_pointages: statistiques.total_pointages || 0,
    absences: statistiques.absences || 0,
    jours_non_travailles: joursNonTravailles,  // ✅ AJOUTE
    vrais_absences: vraisAbsences,  // ✅ AJOUTE
    jours_ouvres_attendus: joursOuvres.length,
    jours_pointes: datesPointees.length,
    jours_manquants: joursManquants.length,
    dates_manquantes: joursManquants,
    peut_payer: joursManquants.length === 0,
    message_erreur: joursManquants.length > 0 
      ? `${joursManquants.length} jour(s) sans pointage` 
      : null
  };

  };



  const handleValidateCalculation = async () => {
  if (salaryPaymentLocked) {
    setShowValidationDialog(false);
    localShowToast(getSalaryLockMessage(), 'error');
    return;
  }

  try {
    setShowValidationDialog(false);
    setIsValidating(true); // ✅ Affiche le dialog de validation
    
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setCalculationValidated(true);
    setIsValidating(false); // ✅ Ferme le dialog
    localShowToast('Calcul validé - Vous pouvez maintenant effectuer le paiement', 'success');
    
  } catch (error) {
    console.error('Erreur validation:', error);
    setIsValidating(false); // ✅ Ferme le dialog en cas d'erreur
    localShowToast('Erreur lors de la validation', 'error');
  }
};




    const handleOpenPaymentDialog = async () => {
  if (salaryPaymentLocked) {
    localShowToast(getSalaryLockMessage(), 'error');
    return;
  }
  await loadModesPaiement();
  
  // 🆕 Réinitialiser les états du dropdown
  setModePaiementSearchTerm('');
  setIsModePaiementDropdownOpen(false);
  // ✅ NE PAS réinitialiser selectedModePaiement ici
  
  setShowPaymentDialog(true);
};




const handleEffectuerPaiement = async () => {
  if (salaryPaymentLocked) {
    localShowToast(getSalaryLockMessage(), 'error');
    return;
  }

  if (!selectedModePaiement) {
    localShowToast('Veuillez sélectionner un mode de paiement', 'error');
    return;
  }

  setShowPaymentDialog(false);
  setIsProcessingPayment(true);
  setPaymentStep('payment');
  
  try {
    const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);
    const isFixe = teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL';
    const calcul = isFixe 
      ? calculerRemunerationFixe(teacher)
      : calculerRemunerationMensuelle(teacher);

    // ✅ VÉRIFICATION SIMPLE (comme les employés)
    if (!calcul || !selectedModePaiement) {
      localShowToast('Données manquantes pour effectuer le paiement', 'error');
      setIsProcessingPayment(false);
      return;
    }

    const justificationRetenue = teacher.justification_retenue_temp || null;
    let paiementData;
    
    if (isFixe) {
      console.log('💰 ÉTAPE 1/2 : Paiement enseignant FIXE/MENSUEL:', {
        employe_id: parseInt(selectedTeacher),
        montant_brut: calcul.salaire_base,
        montant_retenues: calcul.total_retenues,
        montant_net: calcul.salaire_net
      });
      
      paiementData = {
        employe_id: parseInt(selectedTeacher),
        mois: selectedDate.getMonth() + 1,
        annee: selectedDate.getFullYear(),
        annee_scolaire_id: anneeActive?.id || null,
        montant_brut: calcul.salaire_base || 0,
        montant_retenues: calcul.total_retenues || 0,
        justification_retenue: justificationRetenue,
        montant_avances: calcul.total_avances || 0,
        montant_net: calcul.salaire_net || 0,
        nombre_cours: null,
        total_heures: null,
        type_contrat: 'MENSUEL',
        mode_paiement_id: parseInt(selectedModePaiement),
        remarques: `Paiement FIXE/MENSUEL - ${calcul.total_pointages || 0} jours`,
        justification_pointages_manquants: justificationValidationEnseignant || null,
        jours_ouvres: calcul.jours_ouvres_attendus || null,
        jours_pointes: calcul.jours_pointes || null,
        jours_manquants: calcul.jours_manquants || null
      };
    } else {
      console.log('💰 ÉTAPE 1/2 : Paiement enseignant HORAIRE:', {
        employe_id: parseInt(selectedTeacher),
        montant_brut: calcul.totalRemunerationBrute,
        montant_retenues: calcul.totalRetenues,
        montant_net: calcul.totalRemunerationNette
      });
      
      paiementData = {
        employe_id: parseInt(selectedTeacher),
        mois: selectedDate.getMonth() + 1,
        annee: selectedDate.getFullYear(),
        annee_scolaire_id: anneeActive?.id || null, 
        montant_brut: calcul.totalRemunerationBrute || 0,
        montant_retenues: calcul.totalRetenues || 0,
        justification_retenue: justificationRetenue,
        montant_avances: calcul.totalAvances || 0,
        montant_net: calcul.totalRemunerationNette || 0,
        nombre_cours: calcul.nombrePointages || 0,
        total_heures: parseFloat(calcul.totalHeures) || 0,
        type_contrat: 'HORAIRE',
        mode_paiement_id: parseInt(selectedModePaiement),
        remarques: `Paiement HORAIRE - ${calcul.nombrePointages || 0} cours`,
        justification_pointages_manquants: null,
        jours_ouvres: null,
        jours_pointes: null,
        jours_manquants: null
      };
    }

    // 🆕 ÉTAPE 1 : PAIEMENT (8 secondes)
    const response = await api.paiementsSalaires.creerPaiementEnseignant(paiementData);

    if (!response.success) {
      localShowToast(response.message || response.error || 'Erreur lors du paiement', 'error');
      setIsProcessingPayment(false);
      return;
    }

    // 🆕 VÉRIFICATION ADAPTÉE À LA STRUCTURE ENSEIGNANTS
    if (!response.paiement_id) {
      console.error('❌ Réponse API invalide - paiement_id manquant:', response);
      localShowToast('Erreur : Paiement créé mais ID manquant', 'error');
      setIsProcessingPayment(false);
      return;
    }

    console.log('✅ ÉTAPE 1/2 : Paiement enregistré avec succès, ID:', response.paiement_id);

    // Attendre 8 secondes pour laisser lire l'étape 1
    await new Promise(resolve => setTimeout(resolve, 8000));

    // 🆕 ÉTAPE 2 : CLÔTURE (5 secondes)
    setPaymentStep('cloture');
    console.log('🔒 ÉTAPE 2/2 : Clôture du paiement ID:', response.paiement_id);
    
    const clotureResponse = await api.paiementsSalaires.cloturerPaiementEnseignant(response.paiement_id);

    if (!clotureResponse.success) {
      localShowToast('Paiement effectué mais échec de la clôture', 'warning');
      // 🆕 Construire l'objet paiement avec les données disponibles
      setPaiementExistant({
        id: response.paiement_id,
        statut: 'valide',
        ...paiementData
      });
      setPaymentValidated(true);
      setIsProcessingPayment(false);
      return;
    }

    console.log('✅ ÉTAPE 2/2 : Paiement clôturé avec succès');

    // Attendre 5 secondes pour laisser lire l'étape 2
    await new Promise(resolve => setTimeout(resolve, 5000));

    // 🆕 Marquer les avances comme appliquées
    const montantAvances = isFixe ? calcul.total_avances : calcul.totalAvances;
    if (teacher.avances_mois && teacher.avances_mois.length > 0) {
      console.log(`📝 Marquage de ${teacher.avances_mois.length} avance(s) comme appliquée(s)...`);
      
      for (const avance of teacher.avances_mois) {
        if (avance.statut === 'validee') {
          try {
            const markResponse = await api.avancesSalaire.marquerAvanceAppliquee(avance.id);
            if (markResponse.success) {
              console.log(`✅ Avance ${avance.id} (${avance.montant} FCFA) marquée comme appliquée`);
            }
          } catch (error) {
            console.error(`❌ Erreur marquage avance ${avance.id}:`, error);
          }
        }
      }
    }

    // 🆕 Mettre à jour l'état avec le paiement clôturé
    setPaiementExistant({
      id: response.paiement_id,
      statut: 'cloture',
      date_cloture: new Date().toISOString(),
      ...paiementData
    });
    
    await verifierPaiementExistant(selectedTeacher);
    setPaymentValidated(true);

    // 🆕 Recharger les données
    await loadEnseignantsData();

    // 🆕 Toast intelligent
    if (montantAvances > 0) {
      localShowToast(
        `Paiement clôturé avec succès. ${montantAvances.toLocaleString()} FCFA d'avances appliquées.`, 
        'success'
      );
    } else {
      localShowToast('Paiement clôturé avec succès', 'success');
    }

  } catch (error) {
    console.error('❌ Erreur lors du traitement:', error);
    localShowToast(error.message || 'Erreur lors du traitement du paiement', 'error');
  } finally {
    setIsProcessingPayment(false);
    setPaymentStep('payment');
  }
};




  const loadHistoriqueEnseignants = async () => {
    try {
      console.log('📊 Chargement historique enseignants...');
      const response = await api.paiementsSalaires.getHistoriquePaiementsEnseignants();
      
      if (response.success) {
        console.log(`✅ ${response.data?.length || 0} paiements trouvés`);
        return response.data || [];
      } else {
        console.error('❌ Erreur:', response.message);
        localShowToast('Erreur lors du chargement de l\'historique', 'error');
        return [];
      }
    } catch (error) {
      console.error('❌ Erreur chargement historique:', error);
      localShowToast('Erreur lors du chargement de l\'historique', 'error');
      return [];
    }
  };

  const handleDownloadFichePaie = async (paiementId) => {
    try {
      localShowToast('Génération de la fiche de paie en cours...', 'loading');
      
      console.log('📄 Demande de génération fiche paie enseignant:', paiementId);
      
      await api.paiementsSalaires.genererFichePaieEnseignant(paiementId);
      
      localShowToast('Fiche de paie téléchargée avec succès !', 'success');
      
    } catch (error) {
      console.error('❌ Erreur téléchargement fiche enseignant:', error);
      localShowToast(`Erreur: ${error.message || 'Erreur lors du téléchargement'}`, 'error');
    }
  };

  // FIN PARTIE 1 - Le return() commence dans PARTIE 2
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6">
          {/* Bouton retour + En-tête */}
          <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm mb-6">
            <div className="flex items-center mb-4">
              <button 
                onClick={onBackToDashboard}
                className="flex items-center text-[#246990] hover:text-[#1f5a7a] mr-4"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Retour au dashboard
              </button>
            </div>
            
          <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
  <div className="p-2 bg-[#246990] rounded-full mr-4">
    <GraduationCap className="text-white" size={20} />
  </div>
  <div className="flex-1">
    <h1 className="font-medium text-[#246990] text-xl">Paiements des enseignants</h1>
    <p className="text-sm text-gray-600">
      {modeContrat === 'horaire' ? 'Salaires au taux horaire' : 'Salaires fixes mensuels'}
    </p>
  </div>

  <div className="text-right">
    <div className="text-sm text-gray-500">Période sélectionnée</div>
    <div className="font-medium text-gray-800 capitalize">
      {formatDateForDisplay(selectedDate)}
    </div>
    <div className="text-xs text-gray-500">Calculs en cours</div>
  </div>
  
</div>

{/* Rappel avant paiement (version courte, voir SalaryManagementPage) */}
<NoticePaiementCourte />

{/* Navigation et filtres */}
<div className="flex items-center justify-between mb-5">
  {/* Toggle mode de contrat */}
  <div className="flex bg-gray-100 rounded-lg p-1">
    <button
      onClick={() => setModeContrat('horaire')}
      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
        modeContrat === 'horaire'
          ? 'bg-white text-[#246990] shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      }`}
    >
      Contrat horaire
    </button>
    <button
      onClick={() => setModeContrat('fixe')}
      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
        modeContrat === 'fixe'
          ? 'bg-white text-[#246990] shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      }`}
    >
      Contrat fixe
    </button>
  </div>


    {/* Navigation de période */}
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-2 bg-gray-50 rounded-lg p-2">
        <button
          onClick={goToPreviousMonth}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        
        <div className="relative">
          <button
            onClick={() => setShowCalendar(!showCalendar)}
            className="flex items-center px-4 py-2 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
          >
            <Calendar className="h-4 w-4 mr-2 text-[#246990]" />
            <span className="text-sm font-medium text-gray-900 capitalize">
              {formatDateForDisplay(selectedDate)}
            </span>
          </button>

          {showCalendar && (
            <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-4">
              <input
                type="month"
                value={`${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}`}
                onChange={(e) => {
                  const [year, month] = e.target.value.split('-');
                  const newDate = new Date(parseInt(year), parseInt(month) - 1, 1);
                  setSelectedDate(newDate);
                  setShowCalendar(false);
                }}
                className="p-2 border border-gray-300 rounded-md"
              />
            </div>
          )}
        </div>

        <button
          onClick={goToNextMonth}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
        >
          <ChevronRight className="w-4 h-4" />
        </button>

        {/* Bouton Historique */}
        <button
        onClick={() => setShowHistoriqueEnseignants(true)}
        className="px-3 py-2 text-xs bg-[#246990] text-white rounded-md hover:bg-[#246990]/90 transition-colors flex items-center"
      >
        <FolderOpen className="w-3 h-3 mr-1" />
        Registre comptable
      </button>

      </div>     
    </div>
</div>



          </div>

          <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">


           {/* Section 1: Liste des enseignants */}
          <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm xl:col-span-2">
            <div className="p-3 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-4">
              <div className="p-2 bg-[#246990] rounded-full mr-2">
                <Users className="text-white" size={14} />
              </div>
              <div className="flex-1">
                <h2 className="font-medium text-[#246990] text-base">Enseignants</h2>
                <p className="text-xs text-gray-600">Sélection</p>
              </div>
            </div>

            {/* Barre de recherche */}
            <div className="mb-3">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={14} />
                <input
                  type="text"
                  placeholder="Rechercher..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                />
              </div>
            </div>

            {/* Liste compacte enseignant fixe et horaire */}
            <div className="space-y-2 max-h-[500px] overflow-y-auto">
  {loading ? (
    <div className="text-center py-8 text-gray-400">
      <div className="animate-spin w-8 h-8 border-4 border-[#246990] border-t-transparent rounded-full mx-auto"></div>
      <p className="text-sm mt-2">Chargement...</p>
    </div>
  ) : enseignants.length === 0 ? (
    <div className="text-center py-8 text-gray-400">
      <GraduationCap className="w-12 h-12 mx-auto mb-2 opacity-50" />
      <p className="text-sm">Aucun enseignant trouvé</p>
    </div>
  ) : (
    enseignants
      .filter(t => {
        const matchSearch = `${t.prenom} ${t.nom}`.toLowerCase().includes(searchTerm.toLowerCase());
        
        let matchContrat = false;
        if (modeContrat === 'horaire') {
          matchContrat = (t.type_contrat === 'HORAIRE');
       } else {
 matchContrat = (t.type_contrat === 'FIXE' || t.type_contrat === 'MENSUEL');
}
        
        return matchSearch && matchContrat;
      })
      .map((teacher) => (
        <div
          key={teacher.id}
          onClick={() => {
            setSelectedTeacher(teacher.id.toString());
            
            if (teacher.paiement_existe && teacher.paiement_info) {
              console.log(`✅ Enseignant ${teacher.prenom} ${teacher.nom} déjà payé ce mois`);
              setPaiementExistant(teacher.paiement_info);
              setPaymentValidated(true);
              setCalculationValidated(true);
            } else {
              console.log(`ℹ️ Enseignant ${teacher.prenom} ${teacher.nom} pas encore payé ce mois`);
              setPaiementExistant(null);
              setPaymentValidated(false);
              setCalculationValidated(false);
              verifierPaiementExistant(teacher.id.toString());
            }
          }}
          className={`p-2 rounded-lg border cursor-pointer transition-all ${
            selectedTeacher === teacher.id.toString()
              ? 'border-[#246990] bg-blue-50 shadow-sm'
              : 'border-gray-200 hover:border-gray-300 bg-white hover:bg-gray-50'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0">
              {/* Nom + Badge "Payé" */}
              <div className="flex items-center gap-2">
                <div className={`text-sm font-medium truncate ${
                  selectedTeacher === teacher.id.toString() ? 'text-[#246990]' : 'text-gray-900'
                }`}>
                  {teacher.prenom} {teacher.nom}
                </div>
                
                {/* Badge si déjà payé */}
                {enseignantsPaies[teacher.id] && (
                  <span className="text-xs px-2 py-0.5 bg-green-100 text-green-800 rounded-full flex-shrink-0">
                    ✓ Payé
                  </span>
                )}
              </div>
              
              {/* Type de contrat */}
              <div className="text-xs text-gray-500">{teacher.type_contrat || 'HORAIRE'}</div>
            </div>
          </div>
        </div>
      ))
  )}
            </div>
          </div>

          {/* FIN PARTIE 2 - Section 2 (Calcul) commence dans PARTIE 3 */}

  {/* Section 2: Calcul */}


        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm xl:col-span-8">
  <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
    <div className="p-2 bg-[#246990] rounded-full mr-3">
      <Calculator className="text-white" size={16} />
    </div>
    <div className="flex-1">
      <h2 className="font-medium text-[#246990] text-lg">Calcul du salaire</h2>
      <p className="text-sm text-gray-600">Présences et éléments variables</p>
    </div>
  </div>

  {!selectedTeacher ? (
    <div className="text-center py-12 text-gray-400">
      <Calculator className="h-16 w-16 mx-auto mb-4 opacity-50" />
      <h4 className="text-lg font-medium text-gray-700 mb-2">Aucun enseignant sélectionné</h4>
      <p className="text-sm">Sélectionnez un enseignant pour voir ses données</p>
    </div>
  ) : (() => {
    const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);
    
    if (!teacher) {
      return (
        <div className="text-center py-12 text-gray-400">
          <AlertTriangle className="h-16 w-16 mx-auto mb-4 opacity-50" />
          <h4 className="text-lg font-medium text-gray-700 mb-2">Données non disponibles</h4>
        </div>
      );
    }

    const pointages = teacher.pointages || [];
    const stats = teacher.statistiques || {};

    return (
      <>
        {/* WRAPPER AVEC FLOU SI CLÔTURÉ */}
        <div className={paiementExistant?.statut === 'cloture' ? 'opacity-50 pointer-events-none' : ''}>
          
          {/* ========================================= */}
          {/* CONDITION : FIXE ou HORAIRE */}
          {/* ========================================= */}
          
          {(teacher.type_contrat === 'FIXE' || teacher.type_contrat === 'MENSUEL') ? (
            /* ENSEIGNANTS FIXES - TABLEAU SIMPLIFIÉ */
            <div className="space-y-4">
              {/* Résumé enseignant FIXE */}
              <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-medium text-blue-900">
                      {teacher.prenom} {teacher.nom}
                    </div>
                    <div className="text-sm text-blue-700">
                      Enseignant principal - Salaire fixe mensuel
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-medium text-blue-900">
                      {parseFloat(teacher.salaire_fixe || 0).toLocaleString()} FCFA
                    </div>
                    <div className="text-xs text-blue-700">Salaire de base</div>
                    {teacher.salaire_source === 'modification' && (
                      <div className="mt-1 text-[11px] font-semibold text-emerald-700">
                        Modification validee appliquee ce mois
                      </div>
                    )}
                    <div className="mt-2 flex justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => setSalaryRequestEnseignant(teacher)}
                        className="rounded-md border border-blue-200 bg-white px-2 py-1 text-xs font-semibold text-[#246990] hover:bg-blue-50"
                      >
                        Modifier
                      </button>
                      <button
                        type="button"
                        onClick={() => setSalaryHistoryEnseignant(teacher)}
                        className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                      >
                        Historique
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              {/* Statistiques */}
           
              <div className="grid grid-cols-3 gap-3">
                {/* Jours travaillés */}
                <div className="p-3 bg-green-50 rounded-lg border border-green-200">
                  <div className="text-center">
                    <div className="text-xl font-bold text-green-600">
                      {stats.total_pointages || 0}
                    </div>
                    <div className="text-xs text-green-700">Jours travaillés</div>
                  </div>
                </div>
                
                {/* Absences (vraies absences uniquement) */}
                <div className="p-3 bg-red-50 rounded-lg border border-red-200">
                  <div className="text-center">
                    <div className="text-xl font-bold text-red-600">
                      {(() => {
                        const calcul = calculerRemunerationFixe(teacher);
                        return calcul?.vrais_absences || 0;
                      })()}
                    </div>
                    <div className="text-xs text-red-700">Absences</div>
                  </div>
                </div>
                
                {/* Jours non travaillés */}
                <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="text-center">
                    <div className="text-xl font-bold text-gray-600">
                      {(() => {
                        const calcul = calculerRemunerationFixe(teacher);
                        return calcul?.jours_non_travailles || 0;
                      })()}
                    </div>
                    <div className="text-xs text-gray-700">Jours non travaillés</div>
                  </div>
                </div>
              </div>



              {/* Tableau des présences - FORMAT SIMPLIFIÉ */}
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <div className="bg-gray-50 px-3 py-2 border-b border-gray-200">
                  <h4 className="text-sm font-medium text-gray-700">Détail des présences</h4>
                </div>
                
                {pointages.length === 0 ? (
                  <div className="p-6 text-center text-gray-400">
                    <Clock className="w-12 h-12 mx-auto mb-2 opacity-50" />
                    <p className="text-sm">Aucune donnée de présence pour cette période</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto max-h-96 overflow-y-auto">
                    <table className="w-full text-sm">

                     <thead className="bg-gray-50 sticky top-0">
                        <tr className="border-b border-gray-200">
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Date</th>
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Heure pointage</th>
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Statut</th>
                          <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Envoyé par</th>
                        </tr>
                      </thead>

                      <tbody className="divide-y divide-gray-200">
                        {pointages.map((presence, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-3 py-2 whitespace-nowrap text-xs">
                              {new Date(presence.date_pointage).toLocaleDateString('fr-FR')}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-xs font-medium">
                              {presence.heure_debut_locale || '-'}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap">

                              <span className={`text-xs px-2 py-1 rounded-full ${
                                presence.statut === 'present' 
                                  ? 'bg-green-100 text-green-800'
                                  : presence.statut === 'jour_non_travaille'
                                    ? 'bg-gray-100 text-gray-800'  // ✅ Nouveau statut
                                    : 'bg-red-100 text-red-800'
                              }`}>
                                {presence.statut === 'present' 
                                  ? 'Présent'
                                  : presence.statut === 'jour_non_travaille'
                                    ? 'Jour non travaillé'  // ✅ Nouveau label
                                    : 'Absent'}
                              </span>

                            </td>


                            <td className="px-3 py-2 text-xs text-gray-600">
                            {presence.created_by_nom || 'Système'}
                          </td>

                        

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>


          
            {/* Détail du calcul - SIMPLIFIÉ */}
            <div className="p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
            <h4 className="text-sm font-medium text-blue-900 mb-3 flex items-center">
                <Calculator className="w-4 h-4 mr-2" />
                Détail du calcul
            </h4>
            
            {(() => {
                const calcul = calculerRemunerationFixe(teacher);
                if (!calcul) return null;
                
                return (
                <>
                    {/* Stats pointages */}
                   <div className="space-y-2 text-sm mb-4 pb-4 border-b border-blue-200">
                      <div className="flex justify-between">
                        <span className="text-gray-700">Jours ouvrés du mois :</span>
                        <span className="font-bold text-blue-900">{calcul.jours_ouvres_attendus} jours</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-700">Jours pointés :</span>
                        <span className="font-bold text-green-700">{calcul.jours_pointes} jours</span>
                      </div>
                      
                      {/* ✅ AJOUTE CES NOUVELLES LIGNES */}
                      <div className="flex justify-between text-green-600">
                        <span>• Jours travaillés :</span>
                        <span className="font-medium">{stats.total_pointages || 0} jours</span>
                      </div>
                      
                      {calcul.vrais_absences > 0 && (
                        <div className="flex justify-between text-red-600">
                          <span>• Absences :</span>
                          <span className="font-medium">{calcul.vrais_absences} jours</span>
                        </div>
                      )}
                      
                      {calcul.jours_non_travailles > 0 && (
                        <div className="flex justify-between text-gray-600">
                          <span>• Jours non travaillés :</span>
                          <span className="font-medium">{calcul.jours_non_travailles} jours</span>
                        </div>
                      )}
                      
                      {calcul.jours_manquants > 0 && (
                        <div className="flex justify-between text-orange-600">
                          <span>• Jours manquants :</span>
                          <span className="font-medium">{calcul.jours_manquants} jours</span>
                        </div>
                      )}
                    </div>

                    {/* Calcul salaire */}
                    <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                        <span className="text-gray-700 font-medium">Salaire de base :</span>
                        <span className="font-bold text-blue-900">
                        {parseFloat(teacher.salaire_fixe || 0).toLocaleString()} FCFA
                        </span>
                    </div>
                    
                    {/* 🆕 BLOC RETENUES COMPLET */}
                    {(() => {
                        const hasRetenues = calcul.total_retenues > 0;
                        const hasRetenuesPresences = calcul.total_retenues_presences > 0;
                        const hasRetenueGlobale = calcul.retenue_globale > 0;
                        const hasRetenuesEnfants = calcul.retenues_enfants_charge > 0;
                        
                        if (!hasRetenues) return null;
                        
                        return (
                        <div className="space-y-1 mb-2">
                            {/* Retenues absences - Rouge */}
                            {hasRetenuesPresences && (
                            <div className="flex justify-between text-sm text-red-600">
                                <span>Retenues absences/retards :</span>
                                <span className="font-medium">- {calcul.total_retenues_presences.toLocaleString()} FCFA</span>
                            </div>
                            )}
                            
                            {/* Retenue manuelle - Rouge */}
                            {hasRetenueGlobale && (
                            <div className="space-y-1">
                                <div className="flex justify-between text-sm text-red-600">
                                <span>Retenue sur salaire :</span>
                                <span className="font-medium">- {calcul.retenue_globale.toLocaleString()} FCFA</span>
                                </div>
                                {teacher.justification_retenue_temp && (
                                <div className="p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
                                    <span className="font-medium">Motif : </span>
                                    {teacher.justification_retenue_temp}
                                </div>
                                )}
                            </div>
                            )}

                            {/* 🆕 Retenues enfants à charge - Violet (automatiques) */}
                            {hasRetenuesEnfants && (
                            <div className="space-y-1">
                                <div className="flex justify-between text-sm text-purple-600">
                                <span className="flex items-center gap-2">
                                    <Users className="w-3.5 h-3.5" />
                                    Retenues enfants à charge :
                                </span>
                                <span className="font-medium">- {calcul.retenues_enfants_charge.toLocaleString()} FCFA</span>
                                </div>
                                
                                <div className="p-2 bg-purple-50 border border-purple-200 rounded text-xs">
                                <div className="flex items-center justify-between">
                                    <div className="text-purple-700">
                                    <span className="font-medium">{calcul.nombre_enfants_charge} enfant(s) scolarisé(s)</span>
                                    <span className="text-purple-600"> - Déduction automatique</span>
                                    </div>
                                    
                                    <button
                                    onClick={() => {
                                        setSelectedEnseignantEnfantsDetail(teacher);
                                        setShowModalEnfantsCharge(true);
                                    }}
                                    className="text-purple-600 hover:text-purple-800 hover:underline text-xs font-medium flex items-center gap-1"
                                    >
                                    <Users className="w-3 h-3" />
                                    Voir détail
                                    </button>
                                </div>
                                </div>
                            </div>
                            )}

                            {/* Total retenues si plusieurs types */}
                            {((hasRetenuesPresences && hasRetenueGlobale) || 
                            (hasRetenuesPresences && hasRetenuesEnfants) || 
                            (hasRetenueGlobale && hasRetenuesEnfants) ||
                            (hasRetenuesPresences && hasRetenueGlobale && hasRetenuesEnfants)) && (
                            <div className="flex justify-between text-sm text-red-700 font-bold pt-1 border-t border-red-200">
                                <span>Total retenues :</span>
                                <span>- {calcul.total_retenues.toLocaleString()} FCFA</span>
                            </div>
                            )}
                        </div>
                        );
                    })()}
                                
                    {teacher.montant_avances_total > 0 && (
                        <div className="flex justify-between text-orange-600">
                        <span>Avances sur salaire :</span>
                        <span className="font-medium">- {teacher.montant_avances_total.toLocaleString()} FCFA</span>
                        </div>
                    )}
                    
                    <div className="flex justify-between text-lg font-bold text-green-700 pt-2 border-t border-blue-300">
                        <span>Salaire net à payer :</span>
                        <span>
                        {calcul.salaire_net.toLocaleString()} FCFA
                        </span>
                    </div>

                    {/* Bouton retenue manuelle reste inchangé */}
                    <div className="mt-4 pt-4 border-t border-blue-200">
                        <button
                        onClick={() => {
                            setSelectedPresence({ 
                            employe_id: teacher.id, 
                            nom: `${teacher.prenom} ${teacher.nom}`,
                            type: 'enseignant_fixe'
                            });
                            setRetenueAbsence('');
                            setTypeRetenue('avec');
                            setJustificationPasDeRetenue('');
                            setShowRetenueModal(true);
                        }}
                        disabled={paiementExistant?.statut === 'cloture'}
                        className="w-full px-4 py-2.5 text-sm bg-[#c66d59] text-white rounded-lg hover:bg-[#b45d4c] transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                        <CreditCard className="w-4 h-4" />
                        Ajouter/Modifier une retenue sur salaire
                        </button>
                    </div>
                    </div>
                </>
                );
            })()}
            </div>



                {/* ALERTE POINTAGES INCOMPLETS - JUSTE APRÈS */}
                {(() => {
                const calcul = calculerRemunerationFixe(teacher);
                
                if (!calcul || calcul.peut_payer) return null;
                
                
                })()}


              {/* ALERTE POINTAGES INCOMPLETS */}
              {(() => {
                const calcul = calculerRemunerationFixe(teacher);
                
                if (!calcul || calcul.peut_payer) return null;
                
                return (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                    <div className="flex items-start">
                      <AlertTriangle className="w-5 h-5 text-red-600 mr-2 mt-0.5" />
                      <div className="flex-1">
                        <h5 className="font-medium text-red-900 mb-1">Pointages incomplets</h5>
                        <p className="text-sm text-red-700 mb-2">{calcul.message_erreur}</p>
                        <div className="text-xs text-red-600">
                          <div className="mb-1">Jours ouvrés du mois : {calcul.jours_ouvres_attendus} jours</div>
                          <div className="mb-1">Jours pointés : {calcul.jours_pointes} jours</div>
                          <div className="mb-2 font-medium">Jours manquants : {calcul.jours_manquants} jours</div>
                          <div className="text-xs">
                            Dates manquantes : {calcul.dates_manquantes.map(d => 
                              new Date(d).toLocaleDateString('fr-FR')
                            ).join(', ')}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}




              {/* Messages paiement */}
              {paiementExistant && paiementExistant.statut === 'cloture' ? (
                <div className="p-4 bg-red-100 border-2 border-red-300 rounded-lg">
                  <div className="flex items-center mb-2">
                    <AlertTriangle className="w-6 h-6 text-red-600 mr-2" />
                    <h4 className="font-bold text-red-900 text-lg">Paiement cloturé pour cette période</h4>
                  </div>
                  <div className="text-sm text-red-700 space-y-1">
                    <div>Date : {new Date(paiementExistant.date_paiement).toLocaleDateString('fr-FR')}</div>
                    <div>Montant : {paiementExistant.montant_net} FCFA</div>
                    <div>Cloturé le : {paiementExistant.date_cloture ? new Date(paiementExistant.date_cloture).toLocaleDateString('fr-FR') : 'N/A'}</div>
                    <div className="font-medium mt-2">Aucune modification n'est possible</div>
                  </div>
                </div>
              ) : paiementExistant ? (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center mb-2">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                    <h4 className="font-medium text-green-900">Paiement validé</h4>
                  </div>
                  <div className="text-sm text-green-700 space-y-1">
                    <div>Date : {new Date(paiementExistant.date_paiement).toLocaleDateString('fr-FR')}</div>
                    <div>Montant : {paiementExistant.montant_net} FCFA</div>
                  </div>
                </div>
              ) : null}


        
              <SalaryLockPanel />




        
              {/* Bouton validation FIXE */}
<button
  onClick={() => {
    console.log('🔵 Clic sur bouton Valider le calcul (FIXE)');
    if (salaryPaymentLocked) {
      localShowToast(getSalaryLockMessage(), 'error');
      return;
    }
    const calcul = calculerRemunerationFixe(teacher);
    console.log('📊 Calcul:', calcul);
    
    if (calcul && !calcul.peut_payer) {
      console.log('⚠️ Pointages incomplets → Ouverture modale justification');
      setShowJustificationValidationModalEnseignant(true);
    } else {
      console.log('✅ Pointages OK → Ouverture modale validation');
      setShowValidationDialog(true);
    }
  }}
  disabled={calculationValidated || paymentValidated || paiementExistant || salaryPaymentLocked}
  className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
    calculationValidated || paymentValidated || paiementExistant || salaryPaymentLocked
      ? 'bg-gray-400 text-white cursor-not-allowed'
      : 'bg-[#246990] text-white hover:bg-[#1f5a7a]'
  }`}
>
                  {paymentValidated || paiementExistant ? (
                    <div className="flex items-center justify-center">
                      <CheckCircle className="w-5 h-5 mr-2" />
                      Déjà payé ce mois
                    </div>
                  ) : calculationValidated ? (
                    <div className="flex items-center justify-center">
                      <Check className="w-5 h-5 mr-2" />
                      Calcul validé
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">
                      <Brain className="w-5 h-5 mr-2" />
                      Valider le calcul
                    </div>
                  )}
                </button>
            </div>
            
          ) : (
            /* FIN PARTIE 3 - ENSEIGNANTS HORAIRES commence dans PARTIE 4 */

            /* ENSEIGNANTS HORAIRES - TABLEAU DÉTAILLÉ */
            <div className="space-y-4">
              {/* Résumé enseignant */}
              <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-medium text-blue-900">
                      {teacher.prenom} {teacher.nom}
                    </div>
                    <div className="text-sm text-blue-700">
                      {teacher.type_contrat} - {stats.total_pointages || 0} pointages reçus
                    </div>
                  </div>
                </div>
              </div>

              {/* Statistiques */}
              <div className="grid grid-cols-2 gap-3">
                <div className="p-3 bg-green-50 rounded-lg border border-green-200">
                  <div className="text-center">
                    <div className="text-xl font-bold text-green-600">{stats.heures_effectuees || 0}h</div>
                    <div className="text-xs text-green-700">Heures effectuées</div>
                  </div>
                </div>
                <div className="p-3 bg-red-50 rounded-lg border border-red-200">
                  <div className="text-center">
                    <div className="text-xl font-bold text-red-600">{stats.absences || 0}</div>
                    <div className="text-xs text-red-700">Absences</div>
                  </div>
                </div>
              </div>

              {/* Tableau des pointages HORAIRE */}
              <div className="border border-gray-200 rounded-lg overflow-hidden">
                <div className="bg-gray-50 px-3 py-2 border-b border-gray-200">
                  <h4 className="text-sm font-medium text-gray-700">Détail des pointages</h4>
                </div>
                
                {pointages.length === 0 ? (
                  <div className="p-6 text-center text-gray-400">
                    <Clock className="w-12 h-12 mx-auto mb-2 opacity-50" />
                    <p className="text-sm">Aucun pointage reçu pour cette période</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto max-h-96 overflow-y-auto">
                    <table className="w-full text-sm">

                     <thead className="bg-gray-50 sticky top-0">
                      <tr className="border-b border-gray-200">
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Date</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Classe</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Matière</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Horaire prévu</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Pointage début</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Pointage fin</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Statut</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Durée</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Envoyé par</th>
                        
                      </tr>
                    </thead>

                      <tbody className="divide-y divide-gray-200">
                        {pointages.map((pointage, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-3 py-2 whitespace-nowrap text-xs">
                              {new Date(pointage.date_pointage).toLocaleDateString('fr-FR')}
                            </td>
                            <td className="px-3 py-2 text-xs font-medium">
                              {pointage.classe_nom}
                            </td>
                            <td className="px-3 py-2 text-xs text-gray-600">
                              {pointage.matiere_nom || '-'}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-600">
                              {pointage.heure_debut_prevue && pointage.heure_fin_prevue 
                                ? `${pointage.heure_debut_prevue} - ${pointage.heure_fin_prevue}`
                                : '- - -'
                              }
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-xs font-medium">
                              {pointage.heure_arrivee || '-'}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-xs font-medium">
                              {pointage.heure_depart || '-'}
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap">
                              <span className={`text-xs px-2 py-1 rounded-full ${
                                pointage.statut_debut === 'a_temps' 
                                  ? 'bg-green-100 text-green-800'
                                  : pointage.statut_debut === 'retard'
                                    ? 'bg-yellow-100 text-yellow-800'
                                    : 'bg-red-100 text-red-800'
                              }`}>
                                {pointage.statut_debut === 'a_temps' ? 'À l\'heure' : 
                                 pointage.statut_debut === 'retard' ? 'Retard' : 'Absent'}
                              </span>
                            </td>
                            <td className="px-3 py-2 whitespace-nowrap text-xs">
                              {pointage.duree_effective_minutes ? (
                                <div className="flex flex-col">
                                  <span className="font-medium text-gray-900">
                                    {pointage.duree_effective_minutes}min
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    ({(pointage.duree_effective_minutes / 60).toFixed(2)}h)
                                  </span>
                                </div>
                              ) : '-'}
                            </td>


                           <td className="px-3 py-2 text-xs text-gray-600">
                            {pointage.created_by_nom || 'Système'}
                          </td>

                     

                        </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Messages paiement HORAIRE */}
              {paiementExistant && paiementExistant.statut === 'cloture' ? (
                <div className="p-4 bg-red-100 border-2 border-red-300 rounded-lg">
                  <div className="flex items-center mb-2">
                    <AlertTriangle className="w-6 h-6 text-red-600 mr-2" />
                    <h4 className="font-bold text-red-900 text-lg">Paiement cloturé pour cette période</h4>
                  </div>
                  <div className="text-sm text-red-700 space-y-1">
                    <div>Date : {new Date(paiementExistant.date_paiement).toLocaleDateString('fr-FR')}</div>
                    <div>Montant : {paiementExistant.montant_net} FCFA</div>
                    <div>Cloturé le : {paiementExistant.date_cloture ? new Date(paiementExistant.date_cloture).toLocaleDateString('fr-FR') : 'N/A'}</div>
                    <div className="font-medium mt-2">Aucune modification n'est possible</div>
                  </div>
                </div>
              ) : paiementExistant ? (
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center mb-2">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                    <h4 className="font-medium text-green-900">Paiement validé</h4>
                  </div>
                  <div className="text-sm text-green-700 space-y-1">
                    <div>Date : {new Date(paiementExistant.date_paiement).toLocaleDateString('fr-FR')}</div>
                    <div>Montant : {paiementExistant.montant_net} FCFA</div>
                  </div>
                </div>
              ) : null}

              {/* Tableau de calcul de rémunération HORAIRE */}
              {(() => {

                const calcul = calculerRemunerationMensuelle(teacher);
                
                if (!calcul || calcul.lignes.length === 0) return null;
                
                return (
                  <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <div className="bg-[#246990] px-3 py-2 border-b border-gray-200">
                      <h4 className="text-sm font-medium text-white">Calcul de la rémunération</h4>
                    </div>
                    
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                          <tr className="border-b border-gray-200">
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Date</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Classe</th>
                            <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Matière</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-gray-600">Durée (h)</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-gray-600">Taux horaire</th>
                            <th className="px-3 py-2 text-right text-xs font-medium text-gray-600 bg-blue-50">Montant</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {calcul.lignes.map((ligne) => (
                            <tr key={ligne.id} className="hover:bg-gray-50">
                              <td className="px-3 py-2 whitespace-nowrap text-xs">
                                {new Date(ligne.date).toLocaleDateString('fr-FR')}
                              </td>
                              <td className="px-3 py-2 text-xs font-medium">
                                {ligne.classe}
                              </td>
                              <td className="px-3 py-2 text-xs text-gray-600">
                                {ligne.matiere || '-'}
                              </td>
                              <td className="px-3 py-2 text-right text-xs font-medium text-blue-600">
                                {ligne.dureeHeures}h
                              </td>
                              <td className="px-3 py-2 text-right text-xs">
                                {ligne.tauxHoraire} FCFA
                              </td>
                              <td className="px-3 py-2 text-right text-xs font-bold text-green-600 bg-blue-50">
                                {ligne.montant} FCFA
                              </td>
                            </tr>
                          ))}
                        </tbody>


                       <tfoot className="bg-gray-100 border-t-2 border-gray-300">
                        <tr>
                            <td colSpan="3" className="px-3 py-3 text-sm font-bold text-gray-900">
                            TOTAL BRUT
                            </td>
                            <td className="px-3 py-3 text-right text-sm font-bold text-blue-600">
                            {calcul.totalHeures}h
                            </td>
                            <td className="px-3 py-3"></td>
                            <td className="px-3 py-3 text-right text-lg font-bold text-blue-600 bg-blue-50">
                            {calcul.totalRemunerationBrute.toLocaleString()} FCFA
                            </td>
                        </tr>
                        
                        {/* 🆕 Retenues absences - Rouge */}
                        {calcul.totalRetenuesPresences > 0 && (
                            <tr className="bg-red-50">
                            <td colSpan="5" className="px-3 py-2 text-sm text-right text-red-700">
                                Retenues absences/retards :
                            </td>
                            <td className="px-3 py-2 text-right text-sm font-bold text-red-700">
                                - {calcul.totalRetenuesPresences.toLocaleString()} FCFA
                            </td>
                            </tr>
                        )}

                        {/* 🆕 Retenue manuelle - Rouge */}
                        {calcul.retenueGlobale > 0 && (
                            <>
                            <tr className="bg-red-50">
                                <td colSpan="5" className="px-3 py-2 text-sm text-right text-red-700">
                                Retenue sur salaire :
                                </td>
                                <td className="px-3 py-2 text-right text-sm font-bold text-red-700">
                                - {calcul.retenueGlobale.toLocaleString()} FCFA
                                </td>
                            </tr>
                            {teacher.justification_retenue_temp && (
                                <tr className="bg-red-50">
                                <td colSpan="6" className="px-3 py-2">
                                    <div className="p-2 bg-red-100 border border-red-200 rounded text-xs text-red-700">
                                    <span className="font-medium">Motif : </span>
                                    {teacher.justification_retenue_temp}
                                    </div>
                                </td>
                                </tr>
                            )}
                            </>
                        )}

                        {/* 🆕 Retenues enfants à charge - Violet (automatiques) */}
                        {calcul.retenues_enfants_charge > 0 && (
                            <>
                            <tr className="bg-purple-50">
                                <td colSpan="5" className="px-3 py-2 text-sm text-right text-purple-700">
                                <span className="flex items-center justify-end gap-2">
                                    <Users className="w-3.5 h-3.5" />
                                    Retenues enfants à charge :
                                </span>
                                </td>
                                <td className="px-3 py-2 text-right text-sm font-bold text-purple-700">
                                - {calcul.retenues_enfants_charge.toLocaleString()} FCFA
                                </td>
                            </tr>
                            <tr className="bg-purple-50">
                                <td colSpan="6" className="px-3 py-2">
                                <div className="p-2 bg-purple-100 border border-purple-200 rounded text-xs">
                                    <div className="flex items-center justify-between">
                                    <div className="text-purple-700">
                                        <span className="font-medium">{calcul.nombre_enfants_charge} enfant(s) scolarisé(s)</span>
                                        <span className="text-purple-600"> - Déduction automatique</span>
                                    </div>
                                    
                                    <button
                                        onClick={() => {
                                        setSelectedEnseignantEnfantsDetail(teacher);
                                        setShowModalEnfantsCharge(true);
                                        }}
                                        className="text-purple-600 hover:text-purple-800 hover:underline text-xs font-medium flex items-center gap-1"
                                    >
                                        <Users className="w-3 h-3" />
                                        Voir détail
                                    </button>
                                    </div>
                                </div>
                                </td>
                            </tr>
                            </>
                        )}

                        {/* 🆕 Total retenues si plusieurs types */}
                        {((calcul.totalRetenuesPresences > 0 && calcul.retenueGlobale > 0) || 
                            (calcul.totalRetenuesPresences > 0 && calcul.retenues_enfants_charge > 0) || 
                            (calcul.retenueGlobale > 0 && calcul.retenues_enfants_charge > 0) ||
                            (calcul.totalRetenuesPresences > 0 && calcul.retenueGlobale > 0 && calcul.retenues_enfants_charge > 0)) && (
                            <tr className="bg-red-100">
                            <td colSpan="5" className="px-3 py-2 text-sm text-right text-red-800 font-bold">
                                Total retenues :
                            </td>
                            <td className="px-3 py-2 text-right text-sm font-bold text-red-800">
                                - {calcul.totalRetenues.toLocaleString()} FCFA
                            </td>
                            </tr>
                        )}
                                        
                        {/* Avances (inchangé) */}
                        {calcul.totalAvances > 0 && (
                            <tr className="bg-orange-50">
                            <td colSpan="5" className="px-3 py-2 text-sm text-right text-orange-700">
                                Avances sur salaire :
                            </td>
                            <td className="px-3 py-2 text-right text-sm font-bold text-orange-700">
                                - {calcul.totalAvances.toLocaleString()} FCFA
                            </td>
                            </tr>
                        )}
                        
                        {/* Total net (inchangé) */}
                        <tr className="bg-green-100 border-t-2 border-green-300">
                            <td colSpan="5" className="px-3 py-3 text-sm font-bold text-green-900">
                            TOTAL NET À PAYER
                            </td>
                            <td className="px-3 py-3 text-right text-xl font-bold text-green-700 bg-green-50">
                            {calcul.totalRemunerationNette.toLocaleString()} FCFA
                            </td>
                        </tr>
                        </tfoot>

                      </table>
                    </div>
                    
                    <div className="bg-green-50 px-4 py-3 border-t border-green-200">
                      <div className="flex items-center justify-between">
                        <div className="text-sm text-green-700">
                          <span className="font-medium">{calcul.nombrePointages} cours</span> à taux variables
                        </div>
                      </div>
                    </div>

                    {/* BOUTON UNIQUE RETENUE ENSEIGNANTS HORAIRES */}
                    <div className="px-4 py-3 bg-gray-50">
                      <button
                        onClick={() => {
                          setSelectedPresence({ 
                            employe_id: teacher.id, 
                            nom: `${teacher.prenom} ${teacher.nom}`,
                            type: 'enseignant_horaire'
                          });
                          setRetenueAbsence('');
                          setTypeRetenue('avec');
                          setJustificationPasDeRetenue('');
                          setShowRetenueModal(true);
                        }}
                        disabled={paiementExistant?.statut === 'cloture'}
                        className="w-full px-4 py-2.5 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
                      >
                        <Banknote className="w-4 h-4" />
                        Ajouter/Modifier une retenue sur salaire
                      </button>
                    </div>

                    <SalaryLockPanel />



                    <button
                      onClick={() => {
                        if (salaryPaymentLocked) {
                          localShowToast(getSalaryLockMessage(), 'error');
                          return;
                        }
                        setShowValidationDialog(true);
                      }}
                      disabled={calculationValidated || paymentValidated || paiementExistant || salaryPaymentLocked}
                      className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
                        calculationValidated || paymentValidated || paiementExistant || salaryPaymentLocked
                          ? 'bg-gray-400 text-white cursor-not-allowed'
                          : 'bg-[#246990] text-white hover:bg-[#1f5a7a]'
                      }`}
                    >
                      {paymentValidated || paiementExistant ? (
                        <div className="flex items-center justify-center">
                          <CheckCircle className="w-5 h-5 mr-2" />
                          Déjà payé ce mois
                        </div>
                      ) : calculationValidated ? (
                        <div className="flex items-center justify-center">
                          <Check className="w-5 h-5 mr-2" />
                          Calcul validé
                        </div>
                      ) : (
                        <div className="flex items-center justify-center">
                          <Brain className="w-5 h-5 mr-2" />
                          Valider le calcul
                        </div>
                      )}
                    </button>
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </>
    );
  })()}
</div>

          {/* FIN PARTIE 4 - Section 3 (Paiement) commence dans PARTIE 5 */}



          {/* Section 3: Paiement */}
          <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm xl:col-span-2">
            <div className="p-3 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-4">
              <div className="p-2 bg-[#246990] rounded-full mr-2">
                <CreditCard className="text-white" size={14} />
              </div>
              <div className="flex-1">
                <h2 className="font-medium text-[#246990] text-base">Paiement</h2>
                <p className="text-xs text-gray-600">Validation</p>
              </div>
            </div>
            <SalaryLockPanel />


            {/* WRAPPER AVEC FLOU SI CLÔTURÉ */}
            <div className={paiementExistant?.statut === 'cloture' ? 'opacity-50 pointer-events-none' : ''}>
              {!calculationValidated ? (
                <div className="text-center py-8 text-gray-400">
                  <CreditCard className="h-12 w-12 mx-auto mb-2 opacity-50" />
                  <p className="text-xs">Validez le calcul</p>
                </div>
              ) : (() => {


 const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);

// ✅ CORRECTION : Gérer FIXE et MENSUEL ensemble
const calcul = (teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL')
  ? calculerRemunerationFixe(teacher)
  : calculerRemunerationMensuelle(teacher);

// ✅ Montant à afficher selon le type de contrat
const montantAffiche = paiementExistant 
  ? parseFloat(paiementExistant.montant_net || 0)
  : ((teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL')
      ? calcul?.salaire_net
      : calcul?.totalRemunerationNette) || 0;

const montantBrut = paiementExistant
  ? parseFloat(paiementExistant.montant_brut || 0)
  : ((teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL')
      ? calcul?.salaire_base
      : calcul?.totalRemunerationBrute) || 0;

const nombreCours = paiementExistant
  ? paiementExistant.nombre_cours
  : ((teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL')
      ? calcul?.total_pointages
      : calcul?.nombrePointages) || 0;

const totalHeures = paiementExistant
  ? parseFloat(paiementExistant.total_heures || 0)
  : ((teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL')
      ? 0
      : parseFloat(calcul?.totalHeures || 0));
                
                if (!calcul) {
                  return (
                    <div className="text-center py-8 text-gray-400">
                      <AlertTriangle className="h-12 w-12 mx-auto mb-2 opacity-50" />
                      <p className="text-xs">Données indisponibles</p>
                    </div>
                  );
                }
                
                return (
                  <div className="space-y-3">
                    {/* Montant à payer */}
                    <div className="text-center p-3 bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg border border-green-200">
                      <div className="text-xs text-green-600 mb-1 font-medium">Rémunération calculée</div>

                      {/* NOUVEAU */}
                      <div className="text-2xl font-bold text-green-700">
                        {(() => {
                            const calcul = (teacher.type_contrat === 'FIXE' || teacher.type_contrat === 'MENSUEL')
                            ? calculerRemunerationFixe(teacher)
                            : calculerRemunerationMensuelle(teacher);
                            return calcul 
                            ? ((teacher.type_contrat === 'FIXE' || teacher.type_contrat === 'MENSUEL')
                                ? calcul.salaire_net?.toLocaleString()
                                : calcul.totalRemunerationNette?.toLocaleString()) 
                            : '0';
                        })()} FCFA
                        </div>

                      {/* Détails */}
                      <div className="text-xs text-green-600 mt-2 space-y-0.5">
  {(() => {
    const calcul = (teacher.type_contrat === 'FIXE' || teacher.type_contrat === 'MENSUEL')
      ? calculerRemunerationFixe(teacher)
      : calculerRemunerationMensuelle(teacher);
    
    if (!calcul) return null;
    
    if (teacher.type_contrat === 'HORAIRE') {
      return (
        <>
          <div>Brut: {calcul.totalRemunerationBrute?.toLocaleString()} FCFA</div>
          {calcul.totalRetenues > 0 && <div>Retenues: -{calcul.totalRetenues?.toLocaleString()} FCFA</div>}
          {calcul.totalAvances > 0 && <div>Avances: -{calcul.totalAvances?.toLocaleString()} FCFA</div>}
        </>
      );
    } else {
      return (
        <>
          <div>Base: {calcul.salaire_base?.toLocaleString()} FCFA</div>
          {calcul.total_retenues > 0 && <div>Retenues: -{calcul.total_retenues?.toLocaleString()} FCFA</div>}
          {calcul.total_avances > 0 && <div>Avances: -{calcul.total_avances?.toLocaleString()} FCFA</div>}
        </>
      );
    }
  })()}
</div>


                      <div className="text-xs text-green-600 mt-2 space-y-0.5">
                        <div>{nombreCours} cours • {totalHeures}h</div>
                      </div>
                    </div>

                    {/* Actions */}
                    {!paymentValidated ? (
                      <div className="space-y-2">
                        <button
                          onClick={handleOpenPaymentDialog}
                          disabled={salaryPaymentLocked}
                          className="w-full py-2 px-3 bg-[#319190] text-white rounded-lg hover:bg-[#319190]/90 transition-colors text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50"
                        >
                          <div className="flex items-center justify-center">
                            <CreditCard className="w-4 h-4 mr-2" />
                            Effectuer paiement
                          </div>
                        </button>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        {/* Message de confirmation paiement */}
                        <div className="p-3 bg-green-600 text-white rounded-lg text-center">
                          <div className="flex items-center justify-center mb-1">
                            <CheckCircle className="w-5 h-5 mr-2" />
                            <span className="font-medium text-sm">
                              {paiementExistant?.statut === 'cloture' ? 'Paiement clôturé' : 'Paiement effectué'}
                            </span>
                          </div>
                          <div className="text-xs opacity-90">
                            {paiementExistant?.date_paiement 
                              ? new Date(paiementExistant.date_paiement).toLocaleDateString('fr-FR')
                              : new Date().toLocaleDateString('fr-FR')
                            }
                          </div>
                        </div>

                        {/* Récapitulatif */}
                        <div className="p-2 bg-gray-50 rounded-lg border border-gray-200 text-xs space-y-1">
                          <div className="flex justify-between">
                            <span className="text-gray-600">Montant:</span>
                            <span className="font-semibold text-gray-900">{montantAffiche.toLocaleString()} FCFA</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Cours:</span>
                            <span className="font-medium text-gray-900">{nombreCours}</span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-gray-600">Heures:</span>
                            <span className="font-medium text-gray-900">{totalHeures}h</span>
                          </div>
                        </div>

                        {/* Boutons selon statut */}
                        {paiementExistant?.statut !== 'cloture' ? (
                          <>
                          
                          </>
                        ) : (
                          <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                            <div className="flex items-center text-xs text-red-700">
                              <AlertTriangle className="w-4 h-4 mr-2" />
                              <span>Paiement clôturé - Aucune modification possible</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
            {/* FIN DU WRAPPER */}
          </div>


          </div>
          </div>




          {/*  Dialog de validation avec chargement */}
            {isValidating ? (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10001]">
                <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
                  <div className="text-center">
                    <div className="mb-6">
                      <div className="w-16 h-16 mx-auto bg-[#246990] rounded-full flex items-center justify-center animate-pulse">
                        <Calculator className="text-white" size={32} />
                      </div>
                    </div>
                    
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Validation en cours
                    </h3>
                    <p className="text-gray-600 mb-6">
                      Calcul en cours de validation et envoi vers le paiement...
                    </p>
                    
                    {/* Barre de progression */}
                    <motion.div 
                      className="w-full h-2 bg-gray-200 rounded-full overflow-hidden"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                    >
                      <motion.div 
                        className="h-full bg-[#246990]"
                        initial={{ width: "0%" }}
                        animate={{ width: "100%" }}
                        transition={{ duration: 3, ease: "easeInOut" }}
                      />
                    </motion.div>
                  </div>
                </div>
              </div>
            ) : null}

          <ConfirmDialog
            isOpen={showValidationDialog}
            onClose={() => setShowValidationDialog(false)}
            onConfirm={handleValidateCalculation}
            title="Valider le calcul"
            description="Voulez-vous valider ce calcul de rémunération et l'envoyer vers le module de paiement ?"
            confirmText="Valider"
            cancelText="Annuler"
            type="question"
          />


        {/* Dialog de paiement */}
     
            <ConfirmDialog
            isOpen={showPaymentDialog}
            onClose={() => setShowPaymentDialog(false)}
            onConfirm={handleEffectuerPaiement}
            title="Effectuer le paiement"
            description={
                <div className="space-y-3">
                <p>Confirmez le paiement du salaire pour cet enseignant.</p>
                <div className="bg-blue-50 p-3 rounded-lg">
                    <div className="text-sm font-medium text-blue-900">
                    Montant : {(() => {
                        const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);
                        if (!teacher) return '0';
                        const calcul = teacher.type_contrat === 'HORAIRE' 
                        ? calculerRemunerationMensuelle(teacher)
                        : calculerRemunerationFixe(teacher);
                        return calcul 
                        ? (calcul.totalRemunerationNette?.toLocaleString() || calcul.salaire_net?.toLocaleString()) 
                        : '0';
                    })()} FCFA
                    </div>
                </div>

               <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Mode de paiement *
  </label>
  
  <div className="relative mode-paiement-dropdown">
    <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400 pointer-events-none z-10" />
    
    <input
      type="text"
      placeholder="Rechercher un mode de paiement..."


     value={(() => {
      if (selectedModePaiement) {
        const mode = modesPaiement.find(m => m.id.toString() === selectedModePaiement);  // ✅ Cherche par ID
        return mode ? mode.nom : '';
      }
      return modePaiementSearchTerm;
    })()}


      onChange={(e) => {
        setModePaiementSearchTerm(e.target.value);
        setIsModePaiementDropdownOpen(true);
        if (selectedModePaiement) {
          setSelectedModePaiement('');
        }
      }}
      onFocus={() => setIsModePaiementDropdownOpen(true)}
      className="w-full pl-10 pr-10 py-2.5 text-sm border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3084b5] focus:border-[#3084b5] transition-all"
    />
    
    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
      <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>
    
    {/* ✅ Dropdown moderne */}
    {isModePaiementDropdownOpen && !selectedModePaiement && (
      <div className="absolute z-20 w-full top-full mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-xl max-h-64 overflow-y-auto">
        {(() => {
          const filteredModes = modesPaiement.filter(mode => 
            mode.nom.toLowerCase().includes(modePaiementSearchTerm.toLowerCase())
          );
          
          if (filteredModes.length === 0) {
            return (
              <div className="p-4 text-center text-gray-500 text-sm">
                Aucun mode de paiement trouvé
              </div>
            );
          }
          
          return filteredModes.map((mode) => (
            <div

              key={mode.id}
              onClick={() => {
              setSelectedModePaiement(mode.id.toString());  // ✅ Stocke l'ID
              setModePaiementSearchTerm('');
              setIsModePaiementDropdownOpen(false);
            }}
              className="px-4 py-3 hover:bg-[#3084b5]/10 cursor-pointer border-b last:border-b-0 transition-colors group"
            >


              <div className="flex items-center gap-3">
                <div className="flex-shrink-0 w-8 h-8 bg-[#3084b5]/10 rounded-lg flex items-center justify-center group-hover:bg-[#3084b5] transition-colors">
                  <CreditCard className="w-4 h-4 text-[#3084b5] group-hover:text-white transition-colors" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900 text-sm group-hover:text-[#3084b5] transition-colors">
                    {mode.nom}
                  </div>
                </div>
              </div>
            </div>
          ));
        })()}
      </div>
    )}
  </div>
</div>


                </div>
            }
            confirmText={isProcessingPayment ? "Traitement..." : "Confirmer le paiement"}
            cancelText="Annuler"
            type="question"
            loading={isProcessingPayment}
            />






{/* Dialog de traitement du paiement enseignant */}
{isProcessingPayment && (() => {
  const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);
  const isFixe = teacher?.type_contrat === 'FIXE' || teacher?.type_contrat === 'MENSUEL';
  const calcul = isFixe 
    ? calculerRemunerationFixe(teacher)
    : calculerRemunerationMensuelle(teacher);
  const hasEnfantsCharge = calcul?.nombre_enfants_charge > 0;
  const isClotureStep = paymentStep === 'cloture';
  
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[10001]">
      <div className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4">
        {/* Header */}
        <div className="text-center mb-6">
          <div className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center animate-pulse mb-4 shadow-lg ${
            isClotureStep 
              ? 'bg-gradient-to-br from-[#319190] to-[#3084b5]' 
              : 'bg-gradient-to-br from-[#3084b5] to-[#319190]'
          }`}>
            {isClotureStep ? (
              <Check className="text-white" size={36} />
            ) : (
              <CreditCard className="text-white" size={36} />
            )}
          </div>
          
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {isClotureStep ? 'Clôture du paiement' : 'Traitement du paiement'}
          </h3>
          <p className="text-gray-600">
            {isClotureStep 
              ? 'Finalisation en cours...' 
              : `Enregistrement en cours pour ${teacher?.prenom} ${teacher?.nom}`
            }
          </p>
          
          {/* Indicateur d'étape */}
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold ${
              isClotureStep ? 'bg-[#319190] text-white' : 'bg-[#3084b5] text-white'
            }`}>
              {isClotureStep ? '✓' : '1'}
            </div>
            <div className={`h-1 w-12 ${isClotureStep ? 'bg-[#319190]' : 'bg-gray-300'}`}></div>
            <div className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold ${
              isClotureStep ? 'bg-[#319190] text-white' : 'bg-gray-300 text-gray-600'
            }`}>
              2
            </div>
          </div>
        </div>

        {/* Contenu selon l'étape */}
        {!isClotureStep ? (
          /* ÉTAPE 1 : PAIEMENT */
          <div className="space-y-4 mb-6">
            {/* Salaire */}
            <div className="p-4 bg-[#3084b5]/10 rounded-lg border-2 border-[#3084b5]/30">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#3084b5] rounded-lg flex items-center justify-center shadow-md">
                    <Banknote className="text-white" size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-[#3084b5] font-semibold">
                      {isFixe ? 'Salaire mensuel' : 'Salaire horaire'}
                    </p>
                    <p className="text-xs text-[#3084b5]/70">
                      {formatDateForDisplay(selectedDate)}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-[#3084b5]">
                    {(isFixe 
                      ? calcul?.salaire_net 
                      : calcul?.totalRemunerationNette
                    )?.toLocaleString() || 0} FCFA
                  </p>
                  <p className="text-xs text-[#3084b5]/70">Net à payer</p>
                </div>
              </div>
            </div>

            {/* Enfants à charge SI présents */}
            {hasEnfantsCharge && (
              <div className="p-4 bg-purple-50 rounded-lg border-2 border-purple-300">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center shadow-md">
                      <Users className="text-white" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-purple-700 font-semibold">
                        Frais scolaires - Enfants à charge
                      </p>
                      <p className="text-xs text-purple-600">
                        {calcul.nombre_enfants_charge} enfant(s) scolarisé(s)
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-purple-700">
                      {(isFixe 
                        ? calcul?.retenues_enfants_charge 
                        : calcul?.retenues_enfants_charge
                      )?.toLocaleString() || 0} FCFA
                    </p>
                    <p className="text-xs text-purple-600">Déduits automatiquement</p>
                  </div>
                </div>
                
                {/* Liste des enfants */}
                {calcul.detail_enfants_charge && calcul.detail_enfants_charge.length > 0 && (
                  <div className="space-y-1.5 mt-3 pt-3 border-t border-purple-200">
                    {calcul.detail_enfants_charge.map((enfant, index) => (
                      <div key={index} className="flex items-center justify-between text-xs">
                        <span className="text-purple-700">
                          <BookOpen className="w-3 h-3 inline mr-1" />
                          {enfant.prenom} {enfant.nom} - {enfant.classe}
                        </span>
                        <span className="font-medium text-purple-800">
                          {enfant.montant.toLocaleString()} FCFA
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Message automatique */}
            {hasEnfantsCharge && (
              <div className="p-4 bg-[#319190]/10 border-2 border-[#319190]/30 rounded-lg">
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#319190] flex-shrink-0 mt-0.5" />
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-[#319190] mb-1">
                      Paiement automatique des frais scolaires
                    </p>
                    <p className="text-xs text-gray-700 leading-relaxed">
                      Les frais de scolarité de {calcul.nombre_enfants_charge} enfant(s) sont 
                      automatiquement réglés et les statuts de paiement mis à jour dans le module 
                      de gestion scolaire.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          /* ÉTAPE 2 : CLÔTURE */
          <div className="space-y-4 mb-6">
            <div className="p-6 bg-[#319190]/10 rounded-lg border-2 border-[#319190]/40 text-center">
              <CheckCircle className="w-16 h-16 text-[#319190] mx-auto mb-4" />
              <h4 className="text-lg font-bold text-gray-900 mb-2">
                Finalisation du paiement
              </h4>
              <p className="text-sm text-gray-700">
                Le paiement est en cours de clôture définitive.
                <br />
                Cette opération est irréversible.
              </p>
            </div>
          </div>
        )}

        {/* Barre de progression */}
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span className="font-medium">
              {isClotureStep ? 'Étape 2/2 : Clôture...' : 'Étape 1/2 : Paiement...'}
            </span>
            <span className="flex items-center gap-1 text-[#3084b5] font-semibold">
              <Clock className="w-4 h-4" />
              {isClotureStep ? '5 secondes' : '8 secondes'}
            </span>
          </div>
          <motion.div 
            className="w-full h-3 bg-gray-200 rounded-full overflow-hidden shadow-inner"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <motion.div 
              className={`h-full shadow-lg ${
                isClotureStep 
                  ? 'bg-gradient-to-r from-[#319190] to-[#3084b5]'
                  : 'bg-gradient-to-r from-[#3084b5] to-[#319190]'
              }`}
              key={paymentStep}
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: isClotureStep ? 5 : 8, ease: "easeInOut" }}
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
})()}












     

           {/* Modal Historique Enseignants */}
         <HistoriqueEnseignantsModal
          show={showHistoriqueEnseignants}
          onClose={() => setShowHistoriqueEnseignants(false)}
          loadData={loadHistoriqueEnseignants}
          onDownloadFiche={handleDownloadFichePaie}
           showToast={localShowToast}
        />



          {/* Modale Retenue Absence ENSEIGNANTS */}
          {showRetenueModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">Gérer les retenues sur salaire</h3>
                  <button onClick={() => setShowRetenueModal(false)} className="text-gray-400 hover:text-gray-600">
                    <X className="w-5 h-5" />
                  </button>
                </div>

                {/* Affichage employé/enseignant */}
                <div className="mb-4 p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm font-medium text-blue-900">
                    {selectedPresence?.nom}
                  </p>
                  <p className="text-xs text-blue-700">
                    Période : {formatDateForDisplay(selectedDate)}
                  </p>
                </div>

                {/* Choix du type */}
                <div className="mb-4">
                  <div className="flex gap-3">
                    <label className="flex-1 cursor-pointer">
                      <input
                        type="radio"
                        value="avec"
                        checked={typeRetenue === 'avec'}
                        onChange={(e) => setTypeRetenue(e.target.value)}
                        className="sr-only"
                      />
                      <div className={`p-3 rounded-lg border-2 text-center transition-colors ${
                        typeRetenue === 'avec' 
                          ? 'border-red-600 bg-red-50' 
                          : 'border-gray-300 hover:border-gray-400'
                      }`}>
                        <div className="text-sm font-medium">Appliquer une retenue</div>
                      </div>
                    </label>
                    <label className="flex-1 cursor-pointer">
                      <input
                        type="radio"
                        value="sans"
                        checked={typeRetenue === 'sans'}
                        onChange={(e) => setTypeRetenue(e.target.value)}
                        className="sr-only"
                      />
                      <div className={`p-3 rounded-lg border-2 text-center transition-colors ${
                        typeRetenue === 'sans' 
                          ? 'border-green-600 bg-green-50' 
                          : 'border-gray-300 hover:border-gray-400'
                      }`}>
                        <div className="text-sm font-medium">Pas de retenue</div>
                      </div>
                    </label>
                  </div>
                </div>

                {/* Champs pour AVEC retenue */}
                {typeRetenue === 'avec' && (
                  <>
                    {/* Montant de la retenue */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Montant de la retenue (FCFA) *
                      </label>
                      <input
                        type="number"
                        value={retenueAbsence}
                        onChange={(e) => setRetenueAbsence(e.target.value)}
                        placeholder="Ex: 5000"
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                      />
                    </div>

                    {/* Justification de la retenue */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Motif de la retenue *
                      </label>
                      <textarea
                        value={justificationPasDeRetenue}
                        onChange={(e) => setJustificationPasDeRetenue(e.target.value)}
                        placeholder="Ex: Absence injustifiée, retard répété, manquement professionnel..."
                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                        rows="3"
                      />
                    </div>
                  </>
                )}

                {/* Champ justification SANS retenue */}
                {typeRetenue === 'sans' && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Justification de l'absence de retenue *
                    </label>
                    <textarea
                      value={justificationPasDeRetenue}
                      onChange={(e) => setJustificationPasDeRetenue(e.target.value)}
                      placeholder="Ex: Congé maladie justifié, autorisation exceptionnelle..."
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                      rows="3"
                    />
                  </div>
                )}

                <div className="flex gap-3">
                  <button
                    onClick={() => setShowRetenueModal(false)}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                  >
                    Annuler
                  </button>


                  <button
                      onClick={handleSaveRetenueAbsenceEnseignant}
                      disabled={loading}
                      className="flex-1 px-4 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-400"
                    >
                      {loading ? 'Enregistrement...' : 'Enregistrer'}
                    </button>


                </div>
              </div>
            </div>
          )}


          
            {/* Modale Justification Validation ENSEIGNANTS FIXES */}
            {showJustificationValidationModalEnseignant && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Justification requise</h3>
                    <button 
                    onClick={() => {
                        setShowJustificationValidationModalEnseignant(false);
                        setJustificationValidationEnseignant('');
                    }} 
                    className="text-gray-400 hover:text-gray-600"
                    >
                    <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                    <div className="flex items-start">
                    <AlertTriangle className="w-5 h-5 text-orange-600 mr-2 mt-0.5" />
                    <div className="text-sm text-orange-800">
                        {(() => {
                        const teacher = enseignants.find(t => t.id.toString() === selectedTeacher);
                        const calcul = calculerRemunerationFixe(teacher);
                        return (
                            <>
                            <p className="font-medium mb-1">
                                {calcul?.jours_manquants || 0} jour(s) sans pointage
                            </p>
                            <p className="text-xs">
                                Vous devez justifier pourquoi vous validez malgré les pointages manquants.
                            </p>
                            </>
                        );
                        })()}
                    </div>
                    </div>
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                    Justification *
                    </label>
                    <textarea
                    value={justificationValidationEnseignant}
                    onChange={(e) => setJustificationValidationEnseignant(e.target.value)}
                    placeholder="Expliquez pourquoi vous validez malgré les pointages manquants..."
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                    rows="4"
                    />
                </div>

                <div className="flex gap-3">
                    <button
                    onClick={() => {
                        setShowJustificationValidationModalEnseignant(false);
                        setJustificationValidationEnseignant('');
                    }}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                    Annuler
                    </button>
                    <button
                    onClick={() => {
                        if (!justificationValidationEnseignant.trim()) {
                        localShowToast('Veuillez saisir une justification', 'error');
                        return;
                        }
                        console.log('✅ Justification validée:', justificationValidationEnseignant);
                        setShowJustificationValidationModalEnseignant(false);
                        setShowValidationDialog(true);
                    }}
                    className="flex-1 px-4 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] transition-colors"
                    >
                    Continuer
                    </button>
                </div>
                </div>
            </div>
            )}



            
{/* 🆕 ============================================================================ */}
{/* 🆕 MODAL DÉTAIL ENFANTS À CHARGE - ENSEIGNANTS */}
{/* 🆕 ============================================================================ */}
{showModalEnfantsCharge && selectedEnseignantEnfantsDetail && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4">
    <div className="bg-white rounded-lg shadow-2xl max-w-lg w-full max-h-[85vh] overflow-hidden flex flex-col">
      {/* Header Compact */}
      <div className="bg-gradient-to-r from-[#3084b5] to-[#319190] px-5 py-4 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/20 rounded-lg">
              <Users className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold">Enfants à Charge</h3>
              <p className="text-white/90 text-xs">
                {selectedEnseignantEnfantsDetail.prenom} {selectedEnseignantEnfantsDetail.nom}
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowModalEnfantsCharge(false)}
            className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-5">
        {(() => {
          const calcul = selectedEnseignantEnfantsDetail.type_contrat === 'HORAIRE'
            ? calculerRemunerationMensuelle(selectedEnseignantEnfantsDetail)
            : calculerRemunerationFixe(selectedEnseignantEnfantsDetail);
          
          if (!calcul || calcul.nombre_enfants_charge === 0) {
            return (
              <div className="text-center py-8 text-gray-400">
                <Users className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p className="text-sm font-medium text-gray-700">Aucun enfant à charge</p>
                <p className="text-xs text-gray-500 mt-1">Pas de déduction active</p>
              </div>
            );
          }

          const enfants = Array.isArray(calcul.detail_enfants_charge) 
            ? calcul.detail_enfants_charge 
            : [];

          return (
            <div className="space-y-4">
              {/* Statistiques compactes */}
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
                  <p className="text-xs text-blue-600 font-medium mb-1">Enfants</p>
                  <p className="text-2xl font-bold text-blue-900">{calcul.nombre_enfants_charge}</p>
                </div>
                <div className="bg-purple-50 rounded-lg p-3 border border-purple-100">
                  <p className="text-xs text-purple-600 font-medium mb-1">Retenue totale</p>
                  <p className="text-xl font-bold text-purple-900">
                    {calcul.retenues_enfants_charge.toLocaleString()}
                  </p>
                  <p className="text-xs text-purple-600">FCFA</p>
                </div>
              </div>

              {/* Liste compacte des enfants */}
              <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                  Détail des déductions
                </h4>
                <div className="space-y-2">
                  {enfants.map((enfant, index) => (
                    <div 
                      key={enfant.eleve_id}
                      className="bg-white rounded-lg border border-gray-200 p-3 hover:border-[#3084b5] transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        {/* Info enfant */}
                        <div className="flex items-center gap-2.5 flex-1 min-w-0">
                          <div className="w-8 h-8 bg-gradient-to-br from-[#3084b5] to-[#319190] rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                            {enfant.prenom?.charAt(0)}{enfant.nom?.charAt(0)}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="font-medium text-gray-900 text-sm truncate">
                              {enfant.prenom} {enfant.nom}
                            </p>
                            <div className="flex items-center gap-2 text-xs text-gray-500">
                              <span className="flex items-center gap-1">
                                <BookOpen className="w-3 h-3" />
                                {enfant.classe}
                              </span>
                              <span className="text-gray-300">•</span>
                              <span className="flex items-center gap-1">
                                <Badge className="w-3 h-3" />
                                {enfant.matricule}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Montant */}
                        <div className="text-right ml-2">
                          <p className="text-sm font-bold text-[#3084b5]">
                            {enfant.montant.toLocaleString()}
                          </p>
                          <p className="text-xs text-gray-500">FCFA</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Note informative compacte */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <div className="flex gap-2">
                  <AlertCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <p className="text-xs text-blue-800 leading-relaxed">
                    Ces montants sont automatiquement déduits du salaire mensuel pour 
                    chaque enfant scolarisé dans l'établissement.
                  </p>
                </div>
              </div>
            </div>
          );
        })()}
      </div>

      {/* Footer Corporate */}
      <div className="px-5 py-3 bg-gray-50 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <p className="text-xs text-gray-500">
            📅 {formatDateForDisplay(selectedDate)}
          </p>
          <button
            onClick={() => setShowModalEnfantsCharge(false)}
            className="px-4 py-1.5 bg-[#3084b5] text-white rounded-md hover:bg-[#2a6d9a] transition-colors text-sm font-medium"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
)}   



          
            <SalaryModificationRequestModal
              open={!!salaryRequestEnseignant}
              employee={salaryRequestEnseignant}
              selectedDate={selectedDate}
              anneeActive={anneeActive}
              typePersonnel="enseignant"
              onClose={() => setSalaryRequestEnseignant(null)}
              onSuccess={loadEnseignantsData}
              showToast={localShowToast}
            />

            <SalaryModificationHistoryModal
              open={!!salaryHistoryEnseignant}
              employee={salaryHistoryEnseignant}
              selectedDate={selectedDate}
              anneeActive={anneeActive}
              onClose={() => setSalaryHistoryEnseignant(null)}
              showToast={localShowToast}
            />

            {toast.show && (
                <Toast 
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ show: false, message: '', type: '' })}
                />
            )}
            </div>
</div>
     
  );
};

export default ComptabiliteEnseignants;
